import { ChangeEvent } from 'react';
import { prepareHtml } from 'core/common/utils/prepareHtml';
import { Policy } from 'core/flow/entities/Screens/NebGender';
import { Error } from '../../Error';
import { WrapperStyled, CheckboxStyled, ContainerStyled, CheckboxTextStyled } from './styled';

type PolicyExtendedProps = {
  data: Policy;
  className?: string;
  withoutCheckbox?: boolean;
  isError?: boolean;
  isPolicyAccepted: boolean;
  onPolicyClick: (checked: boolean) => void;
};

export const PolicyExtended = ({
  data,
  onPolicyClick,
  isPolicyAccepted,
  isError = false,
  withoutCheckbox = false,
  className,
}: PolicyExtendedProps) => {
  const handleCheckboxChange = (e: ChangeEvent<HTMLInputElement>) => {
    onPolicyClick(e.target.checked);
  };

  if (withoutCheckbox) {
    return (
      <WrapperStyled className={className}>
        <CheckboxTextStyled dangerouslySetInnerHTML={prepareHtml(data.withoutCheckbox)} />
      </WrapperStyled>
    );
  }

  return (
    <WrapperStyled className={className}>
      <ContainerStyled>
        <CheckboxStyled checked={isPolicyAccepted} onChange={handleCheckboxChange} />
        <CheckboxTextStyled dangerouslySetInnerHTML={prepareHtml(data.withCheckbox)} />
      </ContainerStyled>

      {isError && <Error iconName="danger">{data.withCheckboxError}</Error>}
    </WrapperStyled>
  );
};
